var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShiled2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 32.4243,
    height: 32.4243,
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1853 16.8098L11.561 14.1855L10.1323 15.6142L14.1853 19.6672L22.2914 11.5611L20.8627 10.1324L14.1853 16.8098Z",
    fill: "#1956A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2119 30.3976L9.95417 27.0611C8.17009 26.112 6.67814 24.695 5.63844 22.9622C4.59875 21.2293 4.05057 19.2461 4.05274 17.2253V4.05289C4.0533 3.51559 4.26699 3.00047 4.64692 2.62054C5.02684 2.24062 5.54197 2.02693 6.07926 2.02637H26.3445C26.8818 2.02693 27.3969 2.24062 27.7768 2.62054C28.1567 3.00047 28.3704 3.51559 28.371 4.05289V17.2253C28.3731 19.2461 27.825 21.2293 26.7853 22.9622C25.7456 24.695 24.2536 26.112 22.4695 27.0611L16.2119 30.3976ZM6.07926 4.05289V17.2253C6.07751 18.8787 6.52606 20.5014 7.37678 21.9192C8.22751 23.337 9.44827 24.4964 10.9081 25.2729L16.2119 28.1009L21.5157 25.2729C22.9754 24.4964 24.1962 23.337 25.0469 21.9192C25.8977 20.5014 26.3462 18.8787 26.3445 17.2253V4.05289H6.07926Z",
    fill: "#1956A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShiled2);
export default __webpack_public_path__ + "static/media/icon_Shiled2.c31f1e03b99d6cf021f7360c0520c2dc.svg";
export { ForwardRef as ReactComponent };